
import { commonfunc } from '~/mixin/common'
import { swiperBannerClick } from '~/mixin/swiperBannerClick'
import { pushBannerGtmData } from '~/utils/gtm'

import BaseSwiper from '~/components/molecule/swiper/BaseSwiper.vue'
import BannerMedia from '~/components/common/BannerMedia.vue'

export default {
  name: 'MainBanner',
  components: {
    BaseSwiper,
    BannerMedia
  },
  mixins: [commonfunc, swiperBannerClick],
  props: {
    bannerList: { // 배너, 키비주얼 데이터
      type: [Array, Object],
      default () { return [] }
    }
  },
  mounted () {
    this.$nextTick(() => {
      this.swipeVideoPlay()
      // GTM 트래킹: loop 복제 슬라이드 포함 (mixin addSwiperBannerGtm 사용)
      this.addSwiperBannerGtm(
        this.$refs.swiperMain?.getSwiperInstance(),
        () => this.bannerList,
        (item, realIndex) => this.trackBannerGtm(item, realIndex)
      )
    })
  },
  beforeDestroy () {
    this.resetVideos()
  },
  methods: {
    videoOptions (src, thmn) {
      return {
        controls: false,
        autoplay: false,
        muted: true,
        loop: true, // 반복재생
        preload: 'auto',
        poster: thmn,
        userActions: {
          doubleClick: false,
          hotkeys: false,
        },
        sources: [
          {
            src,
            type: 'video/mp4'
          }
        ],
        playbackRates: [1]
      }
    },
    // GTM 트래킹만 담당 (navigation은 :to/:href 속성이 처리)
    trackBannerGtm (item, realIndex) {
      if (this.$route.path === '/ds') {
        pushBannerGtmData({
          fileNm: item.pcomIconOrglFileNm,
          bannerText: item.banrRplcTextNm,
          index: realIndex + 1,
          location: 'PC홈메인_메인롤링배너'
        }, true)
      } else {
        pushBannerGtmData({ fileNm: item.pcomIconOrglFileNm }, false)
      }
    },
    swipeVideoPlay () { // active 스와이퍼 동영상 재생
      this.resetVideos()
      const activeSlide = this.$refs?.swiperMain?.$el?.querySelector('.swiper-slide-active')
      const activeVideo = activeSlide?.querySelector('video')

      if (activeVideo) { // 동영상 존재하는 경우에만
        activeVideo.currentTime = 0
        const playPromise = activeVideo.play()

        if (playPromise !== undefined) {
          playPromise.catch((error) => {
            console.log(error)
          })
        }
      }
    },
    swipeVideoPause () { // 스와이퍼 동영상 재생 정지
      this.resetVideos()
    },
    resetVideos () {
      const videos = this.$refs?.swiperMain?.$el?.querySelectorAll('video') || []

      videos.forEach((item) => {
        item.pause()
        item.currentTime = 0
      })
    },
    formatPrice (price) {
      if (!price) { return '' }
      return `${Number(price).toLocaleString()}`
    },
    formatText (text) {
      if (!text) { return '' }
      const formattedText = text.replace(/(\\n|\n|\r\n)/g, '<br>')
      return this.unescape(formattedText)
    }
  }
}
